import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input"];

  preserveState() {
    this.inputTarget.value = !$("[data-show-all-target='content'").hasClass("hidden");
  }
}
